import React from 'react';
import _merge from 'lodash/merge';
import { getContext } from 'common';
import Styled from './styles';

export interface TreeFilterMatchesContainerProps extends React.ComponentPropsWithRef<'div'> {
  /** Any content to provide for filter matching such as the number of matches. Consider using `TreeText`. */
  children: React.ReactNode;
  /** Add a shadow under the container. */
  shadow?: boolean;
  /** To override the theme please refer to the "Readme" tab to learn more. */
  theme?: any;
}

/** Component for formatting the Filter matches. Any other props will be provided to the root element. */
const TreeFilterMatchesContainer = React.forwardRef<HTMLElement, TreeFilterMatchesContainerProps>((props: TreeFilterMatchesContainerProps, ref) => getContext(({ RTL, theme }) => {
  const { children, shadow, theme: propTheme, ...otherProps } = props;
  const userTheme = propTheme && propTheme.TREE;
  const resolvedTheme = _merge({}, theme.TREE, userTheme);
  return (
    <Styled.TreeFilterMatchesContainer ref={ref} RTL={RTL} $theme={resolvedTheme} shadow={shadow} {...otherProps}>
      {children}
    </Styled.TreeFilterMatchesContainer>
  );
}));

TreeFilterMatchesContainer.displayName = 'TreeFilterMatchesContainer';

TreeFilterMatchesContainer.defaultProps = {
  shadow: true,
  theme: {},
};

export default TreeFilterMatchesContainer;
